import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareDomainAccessEnabledMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  domainAccessEnabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateShareDomainAccessEnabledMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, domainAccessEnabled: boolean } | { __typename?: 'CollectionShare', id: string, domainAccessEnabled: boolean } | null } | null };


export const UpdateShareDomainAccessEnabled = /*#__PURE__*/ gql`
    mutation UpdateShareDomainAccessEnabled($shareId: ID!, $domainAccessEnabled: Boolean) {
  updateShare(
    input: {shareId: $shareId, settings: {domainAccessEnabled: $domainAccessEnabled}}
  ) {
    share {
      id
      domainAccessEnabled
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareDomainAccessEnabledMutation, UpdateShareDomainAccessEnabledMutationVariables>;

          

          export const useUpdateShareDomainAccessEnabledMutation = (options?:MutationHookOptions<UpdateShareDomainAccessEnabledMutation, UpdateShareDomainAccessEnabledMutationVariables>) => useMutation(UpdateShareDomainAccessEnabled, options);
          

          export type UpdateShareDomainAccessEnabledMutationOptions = MutationHookOptions<UpdateShareDomainAccessEnabledMutation, UpdateShareDomainAccessEnabledMutationVariables>;

          

          export type UpdateShareDomainAccessEnabledMutationResult = ReturnType<typeof useUpdateShareDomainAccessEnabledMutation>[1];

          
